export default "__VITE_ASSET__a3d1d776__"